/**
 * 配置不同环境接口前缀
 * 如果未配置dev为默认配置
 * @param {*} base
 * @example
 * {
 *   dev: 'dev环境配置信息',
 *   test: 'test环境配置信息',
 *   prod: '线上环境配置信息'
 * }
 */

function conf(base = {}) {
  if (process.env.ENV_CONFIG === "prod") {
    // 生产环境下
    return base["prod"];
  }
  if (process.env.ENV_CONFIG === "test") {
    return base["test"];
  }
  // 开发环境
  return base["dev"];
}

// PORTAL 接口打包用//https://www.seafoodlinker.com/api
//http://123.57.49.229/api
export const POR_LOGIN_LOGOUT = conf({
  dev: "/api",
  test: "http://47.95.124.243/api",
  prod: "https://hcdz.seafoodlinker.com/api"
});



// WEBPACK FOOTER //
// ./src/request/config.js